import api from "../apiInstance";
import { PaginatedListResponse, PagingParameters } from "./interfaces/paging";
import { CheckoutPricesResponse } from "./interfaces/Payment";
import { CreateProductModel, CreateProductResponse, DateIntervalModel, PorductSearchFilters, ProductAvailabilityAndDateResponse, ProductEditResponse, ProductListResponse, ProductRemoveResponse, UpdateProductModel, UserProductsListResponse } from "./interfaces/Product";
import {ApiError} from "../apiError";
import axios from "axios";

export const createPost = async (data: CreateProductModel, savedProductId?: number, savedOrderId?: number): Promise<CreateProductResponse> => {
    const res = await api.post<CreateProductResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/create', data, {params: {orderId: savedOrderId, productId: savedProductId}});
    return res.data;
}

export const updateProduct = async (data: UpdateProductModel, productId: number): Promise<ProductEditResponse> => {
    const res = await api.patch<ProductEditResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/update/' + productId, data);
    return res.data;
}

export const getProductsList = async (data: PorductSearchFilters): Promise<PaginatedListResponse<ProductListResponse>> => {
    const res = await api.get<PaginatedListResponse<ProductListResponse>>(process.env.REACT_APP_RENTIC_API_URL! + '/products', {params: data});
    return res.data;
}

export const getUserProducts = async (userId: number, searchQuery: PagingParameters):
    Promise<PaginatedListResponse<UserProductsListResponse>> => {
    const res = await api.get<PaginatedListResponse<UserProductsListResponse>>(
        `${process.env.REACT_APP_RENTIC_API_URL!}/products/user_products?orderBy=visibleUntilDate&orderDirection=DESC`,
        {
            params: {
                userId,
                ...searchQuery,
            },
        }
    );
    return res.data;
};

export const getUserSubscriptionsCount = async (userId: number): Promise<number> => {
    const res = await api.get<number>(
        process.env.REACT_APP_RENTIC_API_URL! + '/products/user_orders_count');

    return res.data;
}

export const deleteProduct = async (productId: number): Promise<ProductRemoveResponse> => {
    const res = await api.delete<ProductRemoveResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/' + productId);
    return res.data;
}

export const getProductDetails = async (productId: number): Promise<ProductListResponse> => {
    try {
        const res = await api.get<ProductListResponse>(`${
            process.env.REACT_APP_RENTIC_API_URL}/products/${productId}`);
        return res.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const errorMessage = (error as any).response?.data?.message ?? "An unexpected error occurred";
            const errorCode = (error as any).response?.data?.productStatusCode; // Extract HTTP status code

            throw new ApiError(String(errorMessage), errorCode);
        } else {
            console.error("Unexpected Error:", error);
            throw new ApiError("An unexpected error occurred");
        }
    }
}

export const getProductDetailsEdit = async (productId: number): Promise<ProductEditResponse> => {
    const res = await api.get<ProductEditResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/private/' + productId);
    return res.data;
}

export const getProductAvailabilityAndPrice = async (dateInterval: DateIntervalModel, productId: number): Promise<ProductAvailabilityAndDateResponse> => {
    const res = await api.post<ProductAvailabilityAndDateResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/products/get_rental_price/' + productId, dateInterval);
    return res.data;
}
export const getTotalAmountOfProducts = async (): Promise<number> => {
    const res = await api.get<number>(process.env.REACT_APP_RENTIC_API_URL! + '/products/platform_total_products_amount');
    return res.data;
}
export const getTotalAmountOfSubscriptions = async (): Promise<number> => {
    const res = await api.get<number>(process.env.REACT_APP_RENTIC_API_URL! + '/products/platform_total_subscriptions_amount');
    return res.data;
}